/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-require-imports */
import classNames from 'classnames';
import styles from './index.module.scss';
import {IMysteryInfo, MysteryShapeType, MysteryType} from './const';

interface IFragment extends IMysteryInfo {
    className?: string;
    needTransitAnimation?: boolean;
}

const NormalPrize = ({
    className,
    ...prize
}: IFragment) => {
    const {prizeKey} = prize;
    const image = MysteryShapeType[prizeKey].image;
    // // 当盲盒奖品为一个知识币时
    // if (prizeKey === MysteryType.coin1) {
    //     return <div>
    //         <div
    //             className={styles.images}
    //             style={{
    //                 backgroundImage: `url("${require(`@/assets/img/mysteryBox/${image}`)}")`,
    //             }}
    //         ></div>
    //     </div>;
    // }
    if (prizeKey === MysteryType.chris20) {
        return <div className={styles.notFragmentSpec}>
            <div
                className={styles.image}
                style={{
                    backgroundImage: `url("${require(`@/assets/img/mysteryBox/${image}`)}")`,
                }}
            ></div>
        </div>;
    }
    return <div className={styles.notFragment}>
        <div className={styles.coin}></div>
        <div className={styles.multi}></div>
        <div
            className={styles.num}
            style={{
                backgroundImage: `url("${require(`@/assets/img/mysteryBox/${image}`)}")`,
            }}
        ></div>
    </div>;
};

const FragmentPrize = ({
    className,
    needTransitAnimation = false,
    ...prize
}: IFragment) => {
    const {
        prizeKey,
        fragmentInfo,
    } = prize;
    const {collectedCount, targetCount} = fragmentInfo;
    const dir = MysteryShapeType[prizeKey].imageDir;
    const bds = MysteryShapeType[prizeKey].imageDir;
    return <div className={classNames(styles.itemWrapper, className)}>
        <div
            className={classNames(
                styles.wholePrize
                // prizeKey === MysteryType.chris150 && styles.chris150
            )}
            style={{
                backgroundImage: `url("${require(`@/assets/img/mysteryBox/${dir}-allPrize.png`)}")`,
            }}
        ></div>
        { // 碎片未集齐时出现的白色边框
            // eslint-disable-next-line max-len
            (collectedCount < targetCount)
            && <div
                className={classNames(
                    styles.bd
                )}
                style={{
                    backgroundImage: `url("${require(`@/assets/img/mysteryBox/${bds}-bd.png`)}")`,
                }}
            ></div>
        }
        {
            // 数量未集齐时展示最后一片碎片 消失的样子
            needTransitAnimation && (collectedCount === targetCount)
            && <div
                className={classNames(
                    styles.fragment,
                    styles.fadeOut,
                    // 圣诞盲盒 后期删除掉
                    prizeKey === MysteryType.chris150 && styles.chris150
                )}
                style={{
                    backgroundImage: `url(${require(`@/assets/img/mysteryBox/${dir}-d${collectedCount}.png`)})`,
                }}
            ></div>
        }
        {
            // 数量未集齐时展示碎片
            (collectedCount < targetCount)
            && (new Array(targetCount)).fill(1).map((_, index) => {
                const isLight = index < collectedCount;
                const maskUrl = `d${index + 1}.png`;
                return <div
                // eslint-disable-next-line react/no-array-index-key
                    key={`${prizeKey}_${index}`}
                    className={classNames(
                        styles.fragment,
                        isLight && styles.hide,
                        // 圣诞盲盒 后期删除掉
                        prizeKey === MysteryType.chris150 && styles.chris150
                    )}
                    style={{
                        backgroundImage: `url(${require(`@/assets/img/mysteryBox/${dir}-${maskUrl}`)})`,
                    }}
                ></div>;
            })
        }
    </div>;
};

export const Fragment = ({
    className,
    needTransitAnimation,
    ...prize
}: IFragment) => {
    const {
        fragmentInfo,
    } = prize;
    const {targetCount} = fragmentInfo;
    const isTotalPrize = targetCount === 1;
    return <div className={classNames(styles.wrapper, className, isTotalPrize && styles.total)}>
        {
            isTotalPrize ?
                <NormalPrize {...prize} />
                : <FragmentPrize
                    {...prize}
                    needTransitAnimation={needTransitAnimation}
                />
        }
    </div>;
};
